import React from 'react'
import "../../../../assets/css/screens/customer/dashboard/myreviews/MyReviews.css";
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import { ArrowLeft} from 'lucide-react';
const reviewsData = [
  {
    id: 1,
    service: "AC Repair",
    customer: "Ali Hassan",
    date: "Mar 18, 2026",
    rating: 5,
    comment: "Excellent work! Very professional and timely.",
  },
  {
    id: 2,
    service: "House Cleaning",
    customer: "Sarah Miller",
    date: "Mar 10, 2026",
    rating: 3,
    comment: "Good service, would recommend.",
  },
  {
    id: 3,
    service: "Pipe Repair",
    customer: "John Smith",
    date: "Feb 28, 2026",
    rating: 5,
    comment: "Fixed the issue quickly. Great job!",
  },
]

const StarRating = ({ rating }) => {
  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${star <= rating ? "filled" : "empty"}`}
        >
          ★
        </span>
      ))}
    </div>
  )
}

const ReviewCard = ({ review }) => {
  return (
    <div className="review-card">
      <div className="review-card-top">
        <span className="review-service">{review.service}</span>
        <span className="review-date">{review.date}</span>
      </div>
      <div className="review-customer">{review.customer}</div>
      <StarRating rating={review.rating} />
      <p className="review-comment">{review.comment}</p>
    </div>
  )
}

const MyReviews = () => {
  return (
    <>
    <AppNavbar/>
   
    <div className="reviews-page">
      <div className="reviews-wrapper">

        {/* Header */}
        <div className="reviews-header">
          <button className="back-btn" onClick={() => window.history.back()}>
            <ArrowLeft size={20}/>
          </button>
          <h2 className="reviews-title">My Reviews</h2>
        </div>

        {/* Cards */}
        <div className="reviews-list">
          {reviewsData.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>

      </div>
    </div>
     </>
  )
}

export default MyReviews